import { defineMessages } from 'react-intl-next';
export var messages = defineMessages({
  title: {
    id: 'custom-sites-extensions.section.manifest.extension-title',
    defaultMessage: 'Section [New]',
    description: 'Title of section extension to be displayed in shortcut macros dropdown.'
  },
  lozengeTitle: {
    id: 'custom-sites-extensions.section.manifest.extension-lozenge-title',
    defaultMessage: 'Section',
    description: 'Title of section extension to be displayed in lozenge'
  },
  description: {
    id: 'custom-sites-extensions.section.manifest.macro-description',
    defaultMessage: 'Group elements together with a background',
    description: 'Description of section extension to be displayed in toolbar/shortcut macros dropdown'
  },
  contentHeader: {
    id: 'custom-sites-extensions.section.manifest.content.header',
    defaultMessage: 'Give your section a title',
    description: "Header of section extension's initial content"
  },
  contentSubHeader: {
    id: 'custom-sites-extensions.section.manifest.content.sub-header',
    defaultMessage: 'Organize elements into sections with customizable backgrounds.',
    description: "Sub-header of section extension's initial content"
  },
  placeHolderTitle: {
    id: 'custom-sites-extensions.section.manifest.content.placeholder-title',
    defaultMessage: 'Placeholder',
    description: 'Title of hub element placeholder extension to be displayed the macro is presented in the editor.'
  }
});